import { _notNil } from '@/littledash';

export const byMetadataPosition =
  <T>(position: (item: T) => number | null | undefined, title: (item: T) => string) =>
  (left: T, right: T): number => {
    const leftPosition = position(left);
    const rightPosition = position(right);

    if (_notNil(leftPosition) && _notNil(rightPosition)) {
      if (leftPosition !== rightPosition) {
        return leftPosition - rightPosition;
      }
    } else if (_notNil(leftPosition)) {
      return -1;
    } else if (_notNil(rightPosition)) {
      return 1;
    }

    return title(left).localeCompare(title(right), undefined, { numeric: true });
  };
